<template>
  <model-form />
</template>

<script>
import ModelForm from '@/components/forms/ModelForm'
export default {
  components: {
    ModelForm
  }
}
</script>
